import { render, staticRenderFns } from "./fileTypeSelector.vue?vue&type=template&id=5a3c506e"
import script from "./fileTypeSelector.vue?vue&type=script&lang=js"
export * from "./fileTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports